import cookiesHandler from '@/composables/cookiesHandler';

/**
 * Mutations
 */
export default {
    /**
       * Auth and Profile informations
       */
    setUser(state, userObj) {
        state.user = userObj;
        state.loggedIn = true;
    },
    setLoggedAs(state, loggedAs) {
        state.user.loggedAs = loggedAs;
    },
    cleanAuthData(state) {
        state.user = {};
        state.loggedIn = false;
        state.context = {};
    },
    /**
     * Session message handler
     */
    setSessionMessage(state, messageInfo) {
        state.sessionMessage = messageInfo.message;
        state.sessionMessageType = messageInfo.type;
    },
    cleanSessionMessage(state) {
        state.sessionMessage = null;
        state.sessionMessageType = null;
    },
    saveOnComboChest(state, values) {
        state.comboChest[values.key] = values.value;
    },
    saveOnDataChest(state, values) {
        state.dataChest[values.key] = values.value;
    },
    cleanDataChest(state) {
        state.dataChest = {};
    },
    cleanComboChest(state) {
        state.comboChest = {};
    },
    removeFromDataChest(state, value) {
        let dataChest = state.dataChest;
        if (dataChest[value.key] != undefined) {
            delete dataChest[value.key];
            state.dataChest = dataChest;
        }
    },
    removeFromComboChest(state, value) {
        let comboChest = state.comboChest;
        if (comboChest[value.key] != undefined) {
            delete comboChest[value.key];
            state.comboChest = comboChest;
        }
    },
    saveCookieAccepted(state, value) {
        state.cookiesAccepted = value.aceppted;
        cookiesHandler.setEncryptedCookie('cookies-acceptance', value.aceppted);
    },
    saveToken(state, value) {
        state.token = value;
    },
    saveRegeneratorCalled(state, value) {
        state.regeneratorCalled = value;
    },
    saveRequestedRoute(state, route = {route: '/', query: {}}) {
        const currRoute = state.requested_route ?? '';
        const currParams = state.requested_route_query ?? {};

        const currentParamsLength = Object.keys(currParams).length;
        const newParamsLength = route.query ? Object.keys(route.query).length : 0;

        if (
            currRoute !== route.route || 
            (currRoute === route.route && newParamsLength > currentParamsLength)
        ) {
            state.requested_route = route.route;
            state.requested_route_query = route.query;
        }
    },
    saveCalledRequests(state, route) {
        state.calledRequests.push(route);
    },
    saveIsLogging(state, value = true) {
        state.isLogging = value;
    },
    saveContext(state, context = null) {
        state.context = context;
    },
    SAVE_PURCHASE_ITEMS(state, items = []) {
        state.purchaseItems = Array.isArray(items) ? items : [];
    }
};